"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPES = exports.FLAGS_CONFIG = exports.FLAGS = exports.DEFAULT_HOTEL_CONFIG = exports.DEFAULT_FEATURE_FLAGS = exports.DEFAULT_CHANNEL_HASH = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var TYPES = {
  BOOLEAN: 'boolean',
  ARRAY: 'array'
};
exports.TYPES = TYPES;
var FLAGS_CONFIG = {
  ENABLE_HOTEL_LANGUAGE_SUPPORT: {
    type: TYPES.ARRAY,
    separator: ',',
    "default": 'en-gb,en-gb,th-th,ms-my,id-id,ja-jp,ko-kr,vi-vn,zh-cn,zh-hk,zh-tw'
  },
  ENABLE_HOTEL_WEB_IOS: {
    type: TYPES.BOOLEAN,
    "default": 'FALSE'
  },
  ENABLE_HOTEL_WEB_ANDROID: {
    type: TYPES.BOOLEAN,
    "default": 'FALSE'
  },
  HOTEL_DISABLE_COUNTRY_FILTER: {
    type: TYPES.BOOLEAN,
    "default": 'FALSE'
  },
  HOTEL_ENABLE_MULTIPLE_ROOMS: {
    type: TYPES.BOOLEAN,
    "default": 'TRUE'
  },
  HOTEL_ENABLE_MOBILE_BANNER: {
    type: TYPES.BOOLEAN,
    "default": 'TRUE'
  },
  HOTEL_ENABLE_SUGGESTIONS_NEW_DESIGN: {
    type: TYPES.BOOLEAN,
    "default": 'TRUE'
  },
  ENABLE_HOTEL_REDIRECT_CTRIP: {
    type: TYPES.BOOLEAN,
    "default": 'FALSE'
  }
};
exports.FLAGS_CONFIG = FLAGS_CONFIG;
var FLAGS = Object.keys(FLAGS_CONFIG);
exports.FLAGS = FLAGS;
var DEFAULT_FEATURE_FLAGS = FLAGS.reduce(function (result, flag) {
  return _objectSpread(_objectSpread({}, result), {}, (0, _defineProperty2["default"])({}, flag, FLAGS_CONFIG[flag]["default"]));
}, {});
exports.DEFAULT_FEATURE_FLAGS = DEFAULT_FEATURE_FLAGS;
var DEFAULT_HOTEL_CONFIG = {
  country: ['MY']
};
exports.DEFAULT_HOTEL_CONFIG = DEFAULT_HOTEL_CONFIG;
var DEFAULT_CHANNEL_HASH = [];
exports.DEFAULT_CHANNEL_HASH = DEFAULT_CHANNEL_HASH;